import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { Suspense } from 'react';
import { AliveScope } from 'react-activation';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { MessageProvider } from './context/MessageContext';
import { ModalProvider } from './context/ModalContext';
import { NotificationProvider } from './context/NotificationContext.tsx';
import { WebSocketProvider } from './context/WebSocketContext.tsx';
import Router from './router';
import Loading from './router/loading';
import { antdTheme } from './theme/antd-theme';
import { defaultInterceptors } from './utils/messageInterceptors';
import { defaultModalInterceptors } from './utils/modalInterceptors';
dayjs.locale('zh-cn');
function App() {
  return (
    <ConfigProvider locale={zhCN} theme={antdTheme}>
      <MessageProvider interceptors={defaultInterceptors}>
        <ModalProvider interceptors={defaultModalInterceptors}>
          <BrowserRouter>
            <AuthProvider>
              <WebSocketProvider
                options={{
                  reconnectAttempts: 5,
                  reconnectInterval: 60000,
                }}
              >
                <NotificationProvider>
                  <AliveScope>
                    <Suspense fallback={<Loading />}>
                      <Router />
                    </Suspense>
                  </AliveScope>
                </NotificationProvider>
              </WebSocketProvider>
            </AuthProvider>
          </BrowserRouter>
        </ModalProvider>
      </MessageProvider>
    </ConfigProvider>
  );
}

export default App;
